<template>
  <div class="fb-list" v-if="list.length">
    <div class="fb-list-item" v-for="item in list">
      <a :href="item.url" class="fb-item" @click="item.video ? showVideo(item, $event) : false">
        <picture class="fb-item-picture">
          <source :srcset="item.image.webp" type="image/webp">
          <source :srcset="item.image.jpeg" type="image/jpeg">
          <img :src="item.image.jpeg" class="fb-item-picture" alt="" loading="lazy"/>
        </picture>
        <div class="fb-item-play" v-if="item.video"></div>
        <div class="fb-item-content" v-else>
          <div class="fb-item-title" v-html="item.title"></div>
          <div class="fb-item-text" v-html="item.text"></div>
        </div>
      </a>
    </div>
    <div class="modal fade video-modal" ref="videoModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="video-modal-content" v-if="videoID">
          <iframe
              class="video-modal-frame"
              :src="'https://www.youtube.com/embed/' + videoID + '?autoplay=1'"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
              allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      list: [],
      videoID: ''
    }
  },
  methods: {
    getList() {
      axios.get('/slider/get-advantages').then((response) => {
        this.list = response.data

        if (this.list.length) {
          this.$nextTick(() => {
            jQuery(this.$refs.videoModal).on('hidden.bs.modal', () => this.videoID = '')
          })
        }
      })
    },
    showVideo(item, e) {
      e.preventDefault()
      this.videoID = item.video
      jQuery(this.$refs.videoModal).modal('show')
    },
  },
  created() {
    this.getList()
  }
}
</script>